import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";
import { LiaAngleLeftSolid } from "react-icons/lia";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import mixpanel from "mixpanel-browser";
import Dojah from "react-dojah";
import Loader from "../../Components/Utils/Loader";
const VerifyID = () => {
  // useEffect(() => {
  //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // }, []);
  const [showNotification, setShowNotification] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const [params] = useSearchParams();
  // const type = params.get("type");

  // useEffect(() => {
  //   if (type !== "nin" && type !== "driver's license") {
  //     // navigate(-1);
  //   }
  // }, []);
  const { user, profile } = useSelector((state) => state.onboarding);

  const appID = "67f3df996161feca857bec55";
  const publicKey = "prod_pk_l1L0s2xQJKOGFGfN5JznfYL06";
  const viewType = "custom";
  const config = {
    widget_id: "67f3e115d523db208bcdc5f8", //this is generated from easyonboard here https://app.dojah.io/easy-onboard
  };
  const userData = {
    first_name: profile?.first_name || user?.name?.split(" ")[1], //Optional
    last_name: profile?.last_name || user?.name?.split(" ")[2], //Optional
    // dob: { $dob }, //YYYY-MM-DD Optional
    residence_country: "NG", //Optional
    email: user?.email, //optional
  };
  const govData = {
    nin: "",
    bvn: "",
    dl: "",
    mobile: user?.phone || profile?.phone || "",
  };
  const response = (type, data) => {
    console.log(type, data);
    if (type === "success") {
      localStorage.setItem("verificationStatus", "Pending-Notification");
      window.location = "/";
    } else if (type === "error") {
      // window.location = "/";
    } else if (type === "close") {
      window.location = "/";
    } else if (type === "begin") {
    } else if (type === "loading") {
    }
  };

  const metadata = {
    user_id: user?.id,
  };
  return (
    <>
      <div className="flex flex-col bg-[#F9FAFA] gap-6 pt-3 pb-3 items-center min-h-screen">
        <Navbar type={3} />

        <div className="w-[95%] overflow-scroll h-full min-h-[80vh]  rounded-[12px] gap-5 p-5 md:p-10 bg-[#FFF] border-[#F2F2F2] border-[1.1px] drop-shadow-custom  max-w-[1664px] flex">
          <div className="flex flex-col flex-1">
            <Loader />

            <Dojah
              response={response}
              appID={appID}
              publicKey={publicKey}
              type={viewType}
              config={config}
              userData={userData}
              govData={govData}
              metadata={metadata}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyID;
